(function(){
'use strict';
var root=document.getElementById('PSWaterChecker');
if(!root)return;
var configEl=document.getElementById('ps-wc-config');
var config={};
try{config=configEl?JSON.parse(configEl.textContent):{};}catch(e){config={};}
if(!config.dataUrl)return;
var els={
form:document.getElementById('ps-wc-search-form'),
input:document.getElementById('ps-wc-suburb-input'),
suggestions:document.getElementById('ps-wc-suggestions'),
loading:document.getElementById('ps-wc-loading'),
exampleRow:document.getElementById('ps-wc-example-chips'),
results:document.getElementById('ps-wc-results'),
stateUnknown:document.getElementById('ps-wc-state-unknown'),
stateOutside:document.getElementById('ps-wc-state-outside'),
stateMultiple:document.getElementById('ps-wc-state-multiple'),
multipleOptions:document.getElementById('ps-wc-multiple-options'),
suburbSuggestions:document.getElementById('ps-wc-suburb-suggestions'),
profileSection:document.getElementById('ps-wc-profile-section'),
profileTitle:document.getElementById('ps-wc-profile-title'),
profileCtaTitle:document.getElementById('ps-wc-profile-cta-title'),
profileCtaBody:document.getElementById('ps-wc-profile-cta-body'),
scoreboard:document.getElementById('ps-wc-scoreboard'),
summaryGrid:document.getElementById('ps-wc-summary-grid'),
freshnessPanel:document.getElementById('ps-wc-freshness-panel'),
decisionSection:document.getElementById('ps-wc-decision-section'),
filterMatchCard:document.getElementById('ps-wc-filter-match-card'),
providerFirstCard:document.getElementById('ps-wc-provider-first-card'),
qualitySection:document.getElementById('ps-wc-quality-section'),
qualityGrid:document.getElementById('ps-wc-quality-grid'),
historySection:document.getElementById('ps-wc-history-section'),
historyTimeline:document.getElementById('ps-wc-history-timeline'),
propertySection:document.getElementById('ps-wc-property-section'),
propertyForm:document.getElementById('ps-wc-property-form'),
propertySubmit:document.getElementById('ps-wc-property-submit'),
propertySkip:document.getElementById('ps-wc-property-skip'),
summarySection:document.getElementById('ps-wc-summary-section'),
summaryBlocks:document.getElementById('ps-wc-summary-blocks'),
ctaSection:document.getElementById('ps-wc-cta-section'),
ctaChips:document.getElementById('ps-wc-cta-chips'),
ctaFacts:document.getElementById('ps-wc-cta-facts'),
tplQualityCard:document.getElementById('ps-wc-tpl-quality-card'),
tplHistoryEvent:document.getElementById('ps-wc-tpl-history-event')
};
function createPSWaterCheckerSafety(){
'use strict';
var BASE='https://guidelines.nhmrc.gov.au/australian-drinking-water-guidelines/part-5/';
var NUMBER='(?:\\d{1,3}(?:,\\d{3})+|\\d+)(?:\\.\\d+)?|\\.\\d+';
NUMBER='(?:'+NUMBER+')(?:[eE][+-]?\\d+)?';
var scalarPattern=new RegExp('^('+NUMBER+')$');
var boundPattern=new RegExp('^(<=|>=|<|>|≤|≥)\\s*('+NUMBER+')$');
var rangePattern=new RegExp('^('+NUMBER+')\\s*(?:–|—|-|\\bto\\b)\\s*('+NUMBER+')$','i');
function text(v){return v===null||v===undefined?'':String(v).trim();}
function normal(v){return text(v).normalize('NFKC').toLowerCase().replace(/\s+/g,' ');}
function number(v){return Number(v.replace(/,/g,''));}
function missing(v){return/^(?:|data_pending|not published|not available|n\/a|null|unknown|[-–—])$/i.test(text(v));}
function blank(kind,raw){return{kind:kind,raw:raw,low:null,high:null,lowOpen:false,highOpen:false};}
function interval(kind,raw,low,high,lowOpen,highOpen){
if(!Number.isFinite(low)||low<0||high<low||(low===high&&(lowOpen||highOpen)))return blank('invalid',raw);
if(high!==Infinity&&!Number.isFinite(high))return blank('invalid',raw);
return{kind:kind,raw:raw,low:low,high:high,lowOpen:!!lowOpen,highOpen:!!highOpen};
}
function parse(v){
if(typeof v!=='number'&&typeof v!=='string'&&v!==null&&v!==undefined)return blank('invalid','');
var raw=text(v),m;
if(missing(v))return blank('missing',raw);
if(/^(?:not detected|nd|below detection|below reporting limit)$/i.test(raw))return blank('not-detected',raw);
if((m=raw.match(scalarPattern)))return interval('scalar',raw,number(m[1]),number(m[1]));
if((m=raw.match(boundPattern))){
var n=number(m[2]);
if(!Number.isFinite(n))return blank('invalid',raw);
return/^(?:<|<=|≤)$/.test(m[1])
?interval('upper-bound',raw,0,n,false,m[1]==='<')
:interval('lower-bound',raw,n,Infinity,m[1]==='>',false);
}
if((m=raw.match(rangePattern)))return interval('range',raw,number(m[1]),number(m[2]));
return blank('invalid',raw);
}
function scalar(v){var p=parse(v);return p.kind==='scalar'?p.low:null;}
function available(r){return!!r&&!r.unavailable&&r.scope!=='not_published'&&!missing(r.value);}
function sourced(r){return available(r)&&/^https:\/\//i.test(text(r.source_url));}
function unit(v){
return normal(v).replace(/[μµ]/g,'u').replace(/₃/g,'3').replace(/₂/g,'2').replace(/\s+/g,'');
}
function measurementUnit(param,r){
var raw=normal(r&&r.unit);
raw=raw.replace(/\s+average(?: free chlorine)?$/,'').replace(/\s*\(?95th percentile\)?$/,'');
if(r&&r.parameter_id==='ph'&&raw==='average')return'ph';
var u=unit(raw).replace(/[()]/g,'');
if(r&&r.parameter_id==='hardness'&&u==='mg/l'&&param&&/caco3|calciumcarbonate/.test(unit(param.unit)))return'mg/lascaco3';
return u;
}
function concentration(r,u){
u=u||unit(r&&r.unit);
var factor={'mg/l':1,'ug/l':0.001,'ng/l':0.000001}[u];
if(factor===undefined)return null;
var p=parse(r.value);
if(p.low===null)return p;
return interval(p.kind,p.raw,p.low*factor,p.high*factor,p.lowOpen,p.highOpen);
}
function reportedRange(param,r){
var raw=text(r.range),u=measurementUnit(param,r),value=raw;
var annotated=/^(range|maximum)\s+/i.test(value);
if(!annotated)return compatibleReading(param,Object.assign({},r,{value:value}));
var maximum=/^maximum\s+/i.test(value);
value=value.replace(/^(range|maximum)\s+/i,'');
if(r.parameter_id==='ph'){
if(/[a-z]/i.test(value))return null;
}else{
var suffix=value.match(/\s+(mg\/L|[uµμ]g\/L|ng\/L|NTU)(?:\s+\(free chlorine\))?$/i);
if(!suffix)return null;
var suffixUnit=unit(suffix[1]);
if(suffixUnit!==u&&!(r.parameter_id==='hardness'&&suffixUnit==='mg/l'&&u==='mg/lascaco3'))return null;
value=value.slice(0,suffix.index);
}
var qualified=value.match(new RegExp('^<\\s*('+NUMBER+')\\s*[–—-]\\s*('+NUMBER+')$'));
if(qualified){
var lower=number(qualified[1]),upper=number(qualified[2]);
if(lower>upper)return null;
value='0–'+upper;
}
var parsed=compatibleReading(param,Object.assign({},r,{value:value}));
if(maximum&&parsed&&parsed.kind!=='scalar')return null;
return parsed;
}
function compare(p,ref){
if(!p||p.low===null||!ref)return'unknown';
var low=ref.min===undefined?0:ref.min,high=ref.max;
if(!Number.isFinite(low)||!Number.isFinite(high)||low>high)return'unknown';
if(p.high<low||(p.high===low&&p.highOpen))return'below-range';
if(p.low>high||(p.low===high&&p.lowOpen))return'above';
if(p.low>=low&&p.high<=high){
if(p.kind==='scalar'&&p.low===high&&ref.min===undefined)return'at';
return ref.min===undefined?(p.high===high&&!p.highOpen?'at-or-below':'below'):'within';
}
return'overlap';
}
function reference(id){
var chemical='physical-chemical-characteristics/';
var map={
lead:{max:0.005,unit:'mg/L',kind:'health',label:'Australian lead guideline',path:chemical+'lead'},
copper:{max:2,unit:'mg/L',kind:'health',label:'Australian copper guideline',path:chemical+'copper'},
fluoride:{max:1.5,unit:'mg/L',kind:'health',label:'Australian fluoride guideline',path:chemical+'fluoride'},
chlorine:{max:5,unit:'mg/L',kind:'health',label:'Australian total-chlorine guideline',path:chemical+'chlorine'},
turbidity:{max:5,unit:'NTU',kind:'aesthetic',label:'Australian turbidity aesthetic reference at the tap',path:chemical+'turbidity'},
hardness:{max:200,unit:'mg/L as CaCO3',kind:'aesthetic',label:'Australian hardness scale-management reference',path:chemical+'hardness-as-calcium-carbonate'},
ph:{min:6.5,max:8.5,unit:'pH',kind:'aesthetic',label:'Australian pH aesthetic range',note:'Up to 9.2 may be tolerated for new concrete tanks or cement-mortar lined pipes when microbiological monitoring shows no deterioration. The usual range is not a universal compliance verdict.',path:chemical+'ph'}
};
var r=map[id];
return r?Object.assign({},r,{source_url:BASE+r.path,verified_on:'2026-10-06'}):null;
}
function compatibleReading(param,r){
if(!r)return null;
var id=r.parameter_id,u=measurementUnit(param,r);
if(id==='chlorine'){
var analyte=normal(r.analyte||r.parameter_name||(param&&param.name));
if(!/^(?:total chlorine|chlorine \(total\)|total_chlorine)$/.test(analyte))return null;
return concentration(r,u);
}
if(['lead','copper','fluoride'].indexOf(id)!==-1)return concentration(r,u);
if(id==='turbidity')return u==='ntu'?parse(r.value):null;
if(id==='ph')return/^(?:ph|phunits|phunit)$/.test(u)?parse(r.value):null;
if(id==='hardness')return/^(?:mg\/las(?:caco3|calciumcarbonate)|mgcaco3\/l)$/.test(u)?parse(r.value):null;
return null;
}
function status(tone,label,body,extra){
return Object.assign({tone:tone,label:label,body:body,providerFirst:false,comparison:'unknown'},extra||{});
}
function ecoli(r){
if(!available(r))return status('neutral','No mapped reading','Missing results are not evidence of bacterial safety.');
if(!sourced(r))return status('neutral','Check the original report','A source link is required before interpreting this E. coli result.');
var u=unit(r.unit),raw=text(r.value),p;
if(/^(?:%compliance|%compliant|%samplescompliant|%ofsamplescompliant|percentcompliance)$/.test(u)){
p=parse(raw.replace(/%$/,'').trim());
if(p.low===null||p.high>100)return status('neutral','Check compliance reporting','This reported value cannot be read as a valid compliance percentage.');
if(p.kind==='scalar'&&p.low===100)return status('neutral','100% reported compliance','This describes the samples and reporting period in the source, not the safety of your tap today.');
if((p.kind==='range'&&p.low<100)||p.high<100||(p.high===100&&p.highOpen))return status('alert','Reported compliance below 100%','Check the original report and current provider advice. This is historical reporting, not a live alert.',{providerFirst:true});
return status('neutral','Qualified compliance result','Read the full reported range and period; do not interpret it as a single percentage.');
}
if(/^(?:cfu|mpn|organisms)\/100ml$/.test(u)){
p=parse(raw);
if((p.kind==='range'&&p.high>0)||(p.kind==='scalar'&&p.low>0))return status('alert','E. coli reported as detected','Read the sample date and provider investigation. Check current official advice before relying on a household filter.',{providerFirst:true});
if(p.kind==='scalar'&&p.low===0)return status('neutral','No E. coli reported in this result','This applies to the reported sample and period only. It is not a current safety assurance.');
if(p.low!==null&&(p.low>0||(p.low===0&&p.lowOpen)))return status('alert','Reported result warrants investigation','Check the E. coli source report and current provider advice.',{providerFirst:true});
return status('neutral','Qualified bacterial result','A detection limit or range is not the same as zero organisms. Read the laboratory method and sampling details.');
}
return status('neutral','Read the E. coli reporting basis','A concentration, detection result and compliance percentage need different interpretations. This result is not automatically graded.');
}
function assess(param,r){
if(!available(r))return status('neutral','No mapped reading','A missing value means the mapped reports do not provide a usable result; it does not mean zero or safe.');
if(r.parameter_id==='e_coli')return ecoli(r);
if(!sourced(r))return status('neutral','Check the original report','A source link is required before automatically comparing this result.');
var ref=reference(r.parameter_id),p=compatibleReading(param,r);
if(!ref||!p)return status('neutral','Reference context only','Confirm the exact analyte, units and reporting basis before comparing this reading with a guideline.',{reference:ref});
if(p.low===null)return status('neutral','Qualified or unavailable measurement','The value is not a single usable measurement. The original wording is retained; missing or undetected values are not converted to zero.',{reference:ref});
var c=compare(p,ref),scope=r.scope==='system_wide'?'Network-wide':'Reported';
var extra={reference:ref,comparison:c,parsed:p};
if(!missing(r.range)){
var range=reportedRange(param,r);
if(range&&range.low!==null&&(range.high>ref.max||(ref.min!==undefined&&range.low<ref.min))){
return status(ref.kind==='health'?'alert':'watch','Reported range extends outside the reference','The displayed value alone does not describe the full published range. Check the source period, sampling locations and current provider advice.',Object.assign(extra,{providerFirst:true,comparison:'range-exceedance'}));
}
}
if(c==='above'||c==='below-range')return status(ref.kind==='health'?'alert':'watch',c==='above'?'Reported result above the reference':'Reported result below the reference range','Check the original report, sampling period and current provider advice. '+(ref.kind==='aesthetic'?'This is an aesthetic or operational reference, not a standalone health verdict.':'A household filter is not a substitute for official advice.'),Object.assign(extra,{providerFirst:true}));
if(c==='overlap')return status('watch','Result does not establish which side of the reference applies','The range or open-ended limit crosses the reference. Do not reduce it to the first number or treat it as a pass.',Object.assign(extra,{providerFirst:true}));
if(c==='at')return status('neutral','Reported result at the reference','This is an exact numerical comparison, not a statement that every sample or your tap complies.',extra);
return status('neutral',scope+(c==='within'?' result within the reference range':(c==='at-or-below'?' result at or below the reference':' result below the reference')),'This compares only the reported result. It does not establish current tap-water safety or compliance of every sample.',extra);
}
function recommendation(results,parameters,mapping){
var usable=(results||[]).filter(sourced);
var assessed=usable.map(function(r){return assess((parameters||[]).filter(function(p){return p.id===r.parameter_id;})[0],r);});
var flagged=assessed.some(function(s){return s.providerFirst;});
if(flagged)return{level:'Provider-first',title:'Read the report and provider advice first',body:'A reported value or range needs context before any product recommendation.',reasons:['This is historical or published reporting, not a live warning or a test of your tap.'],providerFirst:true};
if(!usable.length||!mapping||mapping.mapping_confidence!=='primary_table')return{level:'Unknown',title:'Not enough local evidence to grade a filter need',body:'Missing readings or uncertain suburb mapping must not be presented as low risk.',reasons:['Confirm the supply area and the exact concern before choosing treatment.'],providerFirst:false};
return{level:'Unrated',title:'Choose filtration around your actual goal',body:'Published readings provide context, not a personalised diagnosis or a requirement to buy a filter.',reasons:['Taste and convenience are different questions from treatment of a confirmed contaminant.'],providerFirst:false};
}
function postcode(v){var s=text(v);return/^\d{4}$/.test(s)?s:null;}
function name(v){return normal(v).replace(/\./g,'').replace(/[-’']/g,' ').replace(/\s+/g,' ').trim();}
function parseQuery(v){
var q=normal(v).replace(/,/g,' '),pcs=q.match(/\b\d{4}\b/g)||[];
if(!q)return{state:'empty'};
if(pcs.length>1||/\b\d{1,3}\b|\b\d{5,}\b/.test(q))return{state:'unknown'};
if(/\b(?:nsw|qld|sa|wa|tas|nt|act)\b/.test(q))return{state:'outside'};
var pc=pcs[0]||null;
q=q.replace(/\b(?:vic|victoria)\b/g,'').replace(/\b\d{4}\b/g,'').trim();
if(/[^a-z\s'’.-]/.test(q))return{state:'unknown'};
if(!q&&!pc)return{state:'empty'};
if(pc&&!/^(?:3\d{3}|8\d{3})$/.test(pc))return{state:'outside'};
return{name:name(q),postcode:pc};
}
function matchQuery(v,records,allowPartial){
var q=parseQuery(v);
if(q.state)return{state:q.state,records:[]};
var rows=(records||[]).filter(function(r){return r&&name(r.suburb)&&postcode(r.postcode);});
var exact=rows.filter(function(r){return(!q.name||name(r.suburb)===q.name)&&(!q.postcode||postcode(r.postcode)===q.postcode);});
if(exact.length)return{state:exact.length===1?'exact':'multiple',records:exact};
if(q.postcode){
var outside=!/^3\d{3}$|^8\d{3}$/.test(q.postcode);
return{state:outside?'outside':'unknown',reason:'postcode-or-name-mismatch',records:[]};
}
if(allowPartial&&q.name.length>=2){
var starts=[],contains=[];
rows.forEach(function(r){var n=name(r.suburb);if(n.indexOf(q.name)===0)starts.push(r);else if(n.indexOf(q.name)!==-1)contains.push(r);});
var candidates=starts.concat(contains).slice(0,8);
if(candidates.length)return{state:'multiple',records:candidates};
}
return{state:'unknown',records:[]};
}
function exactLocal(results,zoneId){
return(results||[]).filter(function(r){return r.zone_id===zoneId&&r.scope==='zone'&&sourced(r);});
}
function context(r,mapping){
if(!available(r))return{label:'No mapped reading',detail:'No usable value is included for this parameter.'};
if(r.scope==='system_wide')return{label:'Network-wide result',detail:'This is not a suburb-specific measurement.'};
if(r.scope==='zone'&&mapping&&mapping.mapping_confidence==='primary_table')return{label:'Mapped supply-zone result',detail:'This is a supply-zone report, not a measurement from your tap.'};
return{label:'Indicative supply context',detail:'The suburb-to-supply mapping is uncertain or split. Confirm it with your retailer.'};
}
return Object.freeze({parse:parse,scalar:scalar,available:available,sourced:sourced,compare:compare,reference:reference,assess:assess,ecoli:ecoli,recommendation:recommendation,matchQuery:matchQuery,exactLocal:exactLocal,context:context,unit:unit,normal:normal,name:name});
}
var psSafe=createPSWaterCheckerSafety();
var DATA=null;
var suburbIndex=[];
var activeSuburb=null;
var activeOptionIndex=-1;
var currentMatches=[];
function track(eventName,detail){
var privacy=window.Shopify&&window.Shopify.customerPrivacy;
if(!privacy||typeof privacy.analyticsProcessingAllowed!=='function')return;
try{if(!privacy.analyticsProcessingAllowed())return;}catch(e){return;}
var allowed=['query_length','suburb','postcode','provider_id','provider_name','zone_id','zone_name','mapping_confidence','quality_result_count','display_result_count','match_count','incident_id','product_name','recommendation_level'];
var payload={event:eventName};
allowed.forEach(function(key){
if(!detail||!Object.prototype.hasOwnProperty.call(detail,key))return;
var v=detail[key];
if(typeof v==='string')payload[key]=v.slice(0,140);
else if(typeof v==='number'&&Number.isFinite(v))payload[key]=v;
});
window.dataLayer=window.dataLayer||[];
window.dataLayer.push(payload);
}
function debounce(fn,wait){
var t;
return function(){
var args=arguments,ctx=this;
clearTimeout(t);
t=setTimeout(function(){fn.apply(ctx,args);},wait);
};
}
function slugify(str){
return String(str||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
}
function normalize(str){
return String(str||'').toLowerCase().trim();
}
function byId(list,id){
for(var i=0;i<list.length;i++){if(list[i].id===id)return list[i];}
return null;
}
function providerFor(suburb){return byId(DATA.providers,suburb.provider_id);}
function zoneFor(suburb){return byId(DATA.zones,suburb.zone_id);}
function suburbAnalytics(record,provider,zone){
return{
suburb:record?record.suburb:null,
postcode:record?record.postcode:null,
provider_id:provider?provider.id:null,
provider_name:provider?provider.name:null,
zone_id:zone?zone.id:null,
zone_name:zone?zone.name:null,
mapping_confidence:record?record.mapping_confidence:null
};
}
function isPending(val){
return val===undefined||val===null||val===''||val==='DATA_PENDING';
}
function setHidden(el,hidden){if(el)el.hidden=!!hidden;}
function clearNode(el){while(el&&el.firstChild)el.removeChild(el.firstChild);}
function qualityResultsForZone(zone){
return zone?psSafe.exactLocal(DATA.water_quality_results||[],zone.id):[];
}
function providerZoneForResult(result){
return result&&result.zone_id?byId(DATA.zones||[],result.zone_id):null;
}
function cloneResult(result){
var copy={};
for(var key in result){
if(Object.prototype.hasOwnProperty.call(result,key))copy[key]=result[key];
}
return copy;
}
function fallbackResultForProvider(provider,parameterId){
if(!provider)return null;
var matches=(DATA.water_quality_results||[]).filter(function(result){
var resultZone=providerZoneForResult(result);
return result.parameter_id===parameterId&&
!isPending(result.value)&&
result.scope==='system_wide'&&
resultZone&&
resultZone.provider_id===provider.id;
});
return matches[0]||null;
}
function displayResultsForZone(zone,provider){
var exactResults=qualityResultsForZone(zone);
return(DATA.parameters||[]).map(function(param){
var exact=resultFor(exactResults,param.id);
if(exact)return exact;
var fallback=fallbackResultForProvider(provider,param.id);
if(fallback){
var copy=cloneResult(fallback);
copy._fallback=!zone||fallback.zone_id!==zone.id;
return copy;
}
return{
parameter_id:param.id,
value:'Not published',
unit:'',
scope:'not_published',
unavailable:true,
source_org:provider?provider.name:null
};
});
}
function loadData(){
var message=document.getElementById('ps-wc-load-status');
if(!message&&els.form){
message=document.createElement('p');message.id='ps-wc-load-status';
message.setAttribute('role','status');message.setAttribute('aria-live','polite');
els.form.insertAdjacentElement('afterend',message);
}
if(message){clearNode(message);message.textContent='Loading source data…';message.hidden=false;}
if(els.input)els.input.disabled=true;
root.setAttribute('aria-busy','true');
setHidden(els.loading,false);
if(els.loading)els.loading.classList.add('is-visible');
var controller=typeof AbortController==='function'?new AbortController():null;
var timeout;
var request=fetch(config.dataUrl,Object.assign({credentials:'same-origin'},controller?{signal:controller.signal}:{})).then(function(r){if(!r.ok)throw new Error('Source unavailable');return r.json();});
var timer=new Promise(function(_,reject){
timeout=setTimeout(function(){if(controller)controller.abort();reject(new Error('Data loading timed out'));},8000);
});
return Promise.race([request,timer]).then(function(json){
if(!json||!['suburbs','providers','zones','parameters','water_quality_results'].every(function(key){return Array.isArray(json[key]);}))throw new Error('Unrecognised dataset');
if(!json.parameters.every(function(p){return p&&typeof p.id==='string';}))throw new Error('Unrecognised parameters');
if(!json.water_quality_results.every(function(r){return r&&typeof r.parameter_id==='string';}))throw new Error('Unrecognised results');
DATA=json;buildSuburbIndex();
if(!suburbIndex.length)throw new Error('No valid suburb records');
if(els.input){els.input.disabled=false;els.input.placeholder='Enter your suburb or postcode';}
if(message){message.textContent='';message.hidden=true;}
handleInitialUrlState();
}).catch(function(){
DATA=null;suburbIndex=[];activeSuburb=null;hideAllStates();
if(message){
clearNode(message);
message.appendChild(document.createTextNode('Source data is temporarily unavailable. No water-quality conclusion has been produced. '));
var retry=document.createElement('button');retry.type='button';retry.textContent='Try again';
retry.addEventListener('click',function(){retry.disabled=true;loadData();});
message.appendChild(retry);message.hidden=false;
}
}).finally(function(){
clearTimeout(timeout);root.setAttribute('aria-busy','false');
setHidden(els.loading,true);
if(els.loading)els.loading.classList.remove('is-visible');
});
}
function buildSuburbIndex(){
suburbIndex=(DATA.suburbs||[]).filter(function(s){
return s&&typeof s.suburb==='string'&&/^\d{4}$/.test(String(s.postcode));
}).map(function(s){
var record=Object.assign({},s,{postcode:String(s.postcode)});
return{record:record,label:record.suburb+' VIC '+record.postcode,
searchText:normalize(record.suburb+' '+record.postcode+' vic')};
});
}
function matchSuburbs(query){
var q=normalize(query);
if(/^\d{1,3}$/.test(q))return suburbIndex.filter(function(e){return e.record.postcode.indexOf(q)===0;}).slice(0,8);
var match=psSafe.matchQuery(query,suburbIndex.map(function(e){return e.record;}),true);
return match.records.slice(0,8).map(function(r){return{record:r,label:r.suburb+' VIC '+r.postcode};});
}
function renderSuggestions(matches){
currentMatches=matches;
activeOptionIndex=-1;
clearNode(els.suggestions);
if(!matches.length){
els.suggestions.classList.remove('is-open');
els.input.setAttribute('aria-expanded','false');
return;
}
matches.forEach(function(entry,i){
var li=document.createElement('li');
li.className='ps-wc-suggestion';
li.id='ps-wc-opt-'+i;
li.setAttribute('role','option');
li.setAttribute('aria-selected','false');
var strong=document.createElement('strong');
strong.textContent=entry.record.suburb;
var span=document.createElement('span');
span.textContent='VIC '+entry.record.postcode;
li.appendChild(strong);
li.appendChild(span);
li.addEventListener('mousedown',function(e){
e.preventDefault();
selectSuburb(entry.record);
});
els.suggestions.appendChild(li);
});
els.suggestions.classList.add('is-open');
els.input.setAttribute('aria-expanded','true');
}
function moveActiveOption(delta){
var options=els.suggestions.querySelectorAll('.ps-wc-suggestion');
if(!options.length)return;
activeOptionIndex=(activeOptionIndex+delta+options.length)%options.length;
options.forEach(function(opt,i){
var active=i===activeOptionIndex;
opt.classList.toggle('is-active',active);
opt.setAttribute('aria-selected',active?'true':'false');
});
els.input.setAttribute('aria-activedescendant',options[activeOptionIndex].id);
}
function closeSuggestions(){
els.suggestions.classList.remove('is-open');
els.input.setAttribute('aria-expanded','false');
els.input.removeAttribute('aria-activedescendant');
activeOptionIndex=-1;
}
var onInput=debounce(function(){
var val=els.input.value;
if(val.length===0){closeSuggestions();return;}
track('suburb_search_started',{query_length:val.length});
renderSuggestions(matchSuburbs(val));
},120);
if(els.input){
els.input.addEventListener('input',onInput);
els.input.addEventListener('input',function(){currentMatches=[];closeSuggestions();});
els.input.addEventListener('keydown',function(e){
var isOpen=els.suggestions.classList.contains('is-open');
if(e.key==='ArrowDown'){
e.preventDefault();
if(!isOpen){renderSuggestions(matchSuburbs(els.input.value));}
else{moveActiveOption(1);}
}else if(e.key==='ArrowUp'){
e.preventDefault();
if(isOpen)moveActiveOption(-1);
}else if(e.key==='Escape'){
closeSuggestions();
}else if(e.key==='Enter'){
if(isOpen&&activeOptionIndex>=0&&currentMatches[activeOptionIndex]){
e.preventDefault();
selectSuburb(currentMatches[activeOptionIndex].record);
}
}
});
els.input.addEventListener('blur',function(){
setTimeout(closeSuggestions,100);
});
}
if(els.exampleRow){
els.exampleRow.addEventListener('click',function(e){
var btn=e.target.closest('[data-example]');
if(!btn)return;
els.input.value=btn.dataset.example;
resolveQuery(btn.dataset.example);
});
}
if(els.form){
els.form.addEventListener('submit',function(e){
e.preventDefault();
if(activeOptionIndex>=0&&currentMatches[activeOptionIndex]){
selectSuburb(currentMatches[activeOptionIndex].record);
return;
}
resolveQuery(els.input.value);
});
}
function resolveQuery(query){
closeSuggestions();
if(!DATA)return;
var match=psSafe.matchQuery(query,suburbIndex.map(function(e){return e.record;}),true);
if(match.state==='exact'){selectSuburb(match.records[0]);return;}
activeSuburb=null;
if(match.state==='multiple'){showMultiple(match.records);return;}
if(match.state==='outside'){showOutside();return;}
if(match.state==='empty'){hideAllStates();if(els.results)els.results.classList.remove('is-visible');return;}
showUnknown();
}
function hideAllStates(){
setHidden(els.stateUnknown,true);
setHidden(els.stateOutside,true);
setHidden(els.stateMultiple,true);
setHidden(els.profileSection,true);
setHidden(els.decisionSection,true);
setHidden(els.qualitySection,true);
setHidden(els.historySection,true);
setHidden(els.propertySection,true);
setHidden(els.summarySection,true);
setHidden(els.ctaSection,true);
}
function showResultsRoot(){
els.results.classList.add('is-visible');
}
function suburbLinkButton(record){
var btn=document.createElement('button');
btn.type='button';
btn.className='ps-wc-btn ps-wc-btn--secondary';
btn.textContent=record.suburb+' '+record.postcode;
btn.addEventListener('click',function(){selectSuburb(record);});
return btn;
}
function showUnknown(){
hideAllStates();
showResultsRoot();
track('water_checker_no_match',{
query_length:els.input&&els.input.value?els.input.value.length:0
});
setHidden(els.stateUnknown,false);
clearNode(els.suburbSuggestions);
suburbIndex.slice(0,6).forEach(function(e){
els.suburbSuggestions.appendChild(suburbLinkButton(e.record));
});
els.stateUnknown.scrollIntoView({behavior:'smooth',block:'start'});
}
function showOutside(){
hideAllStates();
showResultsRoot();
track('water_checker_outside_region',{
query_length:els.input&&els.input.value?els.input.value.length:0
});
setHidden(els.stateOutside,false);
els.stateOutside.scrollIntoView({behavior:'smooth',block:'start'});
}
function showMultiple(records){
activeSuburb=null;hideAllStates();showResultsRoot();
track('water_checker_multiple_matches',{match_count:records.length});
setHidden(els.stateMultiple,false);clearNode(els.multipleOptions);
var heading=els.stateMultiple.querySelector('h2,h3');if(heading)heading.textContent='Choose your suburb';
records.forEach(function(r){els.multipleOptions.appendChild(suburbLinkButton(r));});
els.stateMultiple.scrollIntoView({behavior:'smooth',block:'start'});
}
function updateUrl(record,replace){
if(!window.history||!window.history.pushState)return;
var url=new URL(window.location.href);
url.hash='ps-wc-profile-section';
url.searchParams.delete('area');
url.searchParams.set('suburb',record.suburb);
url.searchParams.set('postcode',record.postcode);
if(replace)window.history.replaceState({suburb:record.suburb},'',url.toString());
else window.history.pushState({suburb:record.suburb},'',url.toString());
}
function handleInitialUrlState(){
closeSuggestions();activeSuburb=null;hideAllStates();
if(els.results)els.results.classList.remove('is-visible');
var params=new URLSearchParams(window.location.search);
var suburb=params.get('suburb'),postcode=params.get('postcode'),area=params.get('area');
var hash=window.location.hash.replace(/^#/,'');
if(!suburb&&!postcode&&!area&&hash&&hash.indexOf('ps-wc-')!==0){
try{area=decodeURIComponent(hash);}catch(e){area='';}
}
var name=suburb||area||'';
if(!name&&!postcode){if(els.input)els.input.value='';return;}
if(!suburb&&area){
var named=suburbIndex.filter(function(e){return slugify(e.record.suburb)===slugify(area);});
if(named.length)name=named[0].record.suburb;
}
var query=name+(postcode?' '+postcode:'');
if(els.input)els.input.value=query.trim();
var match=psSafe.matchQuery(query,suburbIndex.map(function(e){return e.record;}),false);
if(match.state==='exact'){renderProfile(match.records[0]);showResultsRoot();updateUrl(match.records[0],true);}
else if(match.state==='multiple')showMultiple(match.records);
else if(match.state==='outside')showOutside();
else showUnknown();
}
function selectSuburb(record){
closeSuggestions();
if(els.input)els.input.value=record.suburb+' '+record.postcode;
track('suburb_selected',{suburb:record.suburb,postcode:record.postcode});
updateUrl(record);
renderProfile(record);
showResultsRoot();
if(els.profileSection)els.profileSection.scrollIntoView({behavior:'smooth',block:'start'});
}
function renderProfile(record){
activeSuburb=record;hideAllStates();
var provider=providerFor(record),zone=zoneFor(record);
var exact=qualityResultsForZone(zone),displayed=displayResultsForZone(zone,provider);
var analytics=suburbAnalytics(record,provider,zone);
analytics.quality_result_count=exact.length;
analytics.display_result_count=displayed.filter(psSafe.sourced).length;
track('water_checker_result_viewed',analytics);
els.profileTitle.textContent=record.suburb+', VIC '+record.postcode;
if(els.profileCtaTitle)els.profileCtaTitle.textContent='Questions about '+record.suburb+' water?';
if(els.profileCtaBody)els.profileCtaBody.textContent='These are published supply reports, not a test of your tap or a live alert. Check the reporting period and mapping below.';
renderScoreboard(record,provider,zone,displayed);
clearNode(els.summaryGrid);setHidden(els.summaryGrid,true);
renderFreshnessPanel(record,provider,zone,displayed);setHidden(els.freshnessPanel,false);
renderDecisionCards(record,provider,zone,displayed);
setHidden(els.profileSection,false);setHidden(els.decisionSection,false);setHidden(els.qualitySection,false);
renderQuality(zone,provider);renderHistory(record,provider,zone);renderCtaFacts(record,provider,zone);
renderPropertyForm();setHidden(els.propertySection,false);setHidden(els.ctaSection,false);
psGateSales(psSafe.recommendation(displayed,DATA.parameters,record));
track('profile_loaded',{suburb:record.suburb,postcode:record.postcode,provider_name:provider?provider.name:null});
}
function readableDate(value){
if(isPending(value))return'Not recorded';
var d=new Date(value);
if(isNaN(d.getTime()))return value;
return d.toLocaleDateString('en-AU',{day:'numeric',month:'short',year:'numeric'});
}
function sourceYearSummary(results){
var years=[];
results.forEach(function(result){
if(result.reporting_period&&years.indexOf(result.reporting_period)===-1)years.push(result.reporting_period);
});
return years.length?years.join(', '):'Latest verified source';
}
function mappingCoverageLabel(record){
if(record&&record.mapping_confidence==='primary_table')return'Department of Health mapped supply-zone';
if(record&&record.mapping_confidence==='split_sampling_area')return'split sampling-area context';
if(record&&record.mapping_confidence==='unresolved_primary_table')return'unresolved Health-table sampling area';
if(record&&record.mapping_confidence==='secondary_cross_check')return'indicative cross-checked supply-zone';
return'provider supply-zone';
}
function incidentsFor(record,provider,zone){
return(DATA.incidents||[]).filter(function(incident){
return incidentMatches(incident,record,provider,zone)&&!isPending(incident.summary);
});
}
function journeyPrimarySignal(results){
var rec=psSafe.recommendation(results,DATA.parameters,activeSuburb);
return{label:rec.providerFirst?'Provider advice first':'Published supply context',title:rec.title,body:rec.body};
}
function journeyMetric(label,value,body,tone){
var node=document.createElement('div');
node.className='ps-wc-journey-metric'+(tone?' ps-wc-journey-metric--'+tone:'');
var small=document.createElement('span');
small.textContent=label;
var strong=document.createElement('strong');
strong.textContent=value;
var copy=document.createElement('p');
copy.textContent=body;
node.appendChild(small);
node.appendChild(strong);
node.appendChild(copy);
return node;
}
function journeyResultValue(results,parameterId){
var result=resultFor(results,parameterId);
if(!result||result.unavailable)return'Not published';
return shortValue(result);
}
function renderScoreboard(record,provider,zone,results){
if(!els.scoreboard)return;clearNode(els.scoreboard);
var signal=journeyPrimarySignal(results);
var hero=document.createElement('div');hero.className='ps-wc-journey-hero';
var copy=document.createElement('div');copy.className='ps-wc-journey-copy';
var eyebrow=document.createElement('span');eyebrow.className='ps-wc-journey-eyebrow';eyebrow.textContent=signal.label;
var title=document.createElement('h3');title.textContent=record.suburb+' water, in context';
var body=document.createElement('p');body.textContent='Read the published values with their source, reporting period and coverage. This is not a current safety assessment of your tap.';
var signalNode=document.createElement('div');signalNode.className='ps-wc-journey-signal';
var strong=document.createElement('strong');strong.textContent=signal.title;
var small=document.createElement('span');small.textContent=signal.body;signalNode.appendChild(strong);signalNode.appendChild(small);
var actions=document.createElement('div');actions.className='ps-wc-journey-actions';
var enquire=document.createElement('a');enquire.href='/pages/contact';enquire.className='ps-wc-btn ps-wc-btn--primary';enquire.textContent='Ask about filtration';
var shop=document.createElement('a');shop.href='/collections/residential';shop.className='ps-wc-btn ps-wc-btn--secondary';shop.textContent='Compare home systems';
actions.appendChild(enquire);actions.appendChild(shop);copy.appendChild(eyebrow);copy.appendChild(title);copy.appendChild(body);copy.appendChild(signalNode);copy.appendChild(actions);
var metrics=document.createElement('div');metrics.className='ps-wc-journey-metrics';
metrics.appendChild(journeyMetric('Supply context',zone?zone.name:(provider?provider.name:'Not confirmed'),record.mapping_confidence==='primary_table'?'Mapped supply zone; not an individual tap sample.':'Indicative or split mapping. Confirm with your retailer.','neutral'));
['e_coli','chlorine','turbidity'].forEach(function(id){
var result=resultFor(results,id),p=byId(DATA.parameters||[],id),s=psSafe.assess(p,result);
metrics.appendChild(journeyMetric(id==='e_coli'?'E. coli report':(p?p.name:id),journeyResultValue(results,id),s.body,s.tone==='alert'?'watch':'neutral'));
});
hero.appendChild(copy);hero.appendChild(metrics);els.scoreboard.appendChild(hero);
var reference=document.createElement('div');reference.className='ps-wc-journey-reference';
var label=document.createElement('strong');label.textContent='Choose a filter by its specific performance';
var note=document.createElement('span');note.textContent='Taste, visible particles and a confirmed chemical concern are different goals. General carbon, sediment or reverse-osmosis labels do not prove every contaminant-reduction claim.';
reference.appendChild(label);reference.appendChild(note);els.scoreboard.appendChild(reference);
}
function renderFreshnessPanel(record,provider,zone,results){
if(!els.freshnessPanel)return;clearNode(els.freshnessPanel);
var details=document.createElement('details');details.className='ps-wc-freshness-details';
var summary=document.createElement('summary');summary.textContent='Source dates and coverage';details.appendChild(summary);
var grid=document.createElement('div');grid.className='ps-wc-freshness-grid';
var items=[['Reporting periods',(results.some(psSafe.sourced)?sourceYearSummary(results.filter(psSafe.sourced)):'No sourced reporting period available')],['Dataset date supplied by source file',readableDate(DATA.meta&&DATA.meta.last_updated)],['Supply-zone results',String(qualityResultsForZone(zone).length)],['Network-wide results',String(results.filter(function(r){return r.scope==='system_wide'&&psSafe.sourced(r);}).length)],['Mapping',mappingCoverageLabel(record)],['Current alerts','Check your water retailer; this is not a live alert feed']];
items.forEach(function(pair){var div=document.createElement('div');div.className='ps-wc-freshness-item';var l=document.createElement('span');l.textContent=pair[0];var v=document.createElement('strong');v.textContent=pair[1];div.appendChild(l);div.appendChild(v);grid.appendChild(div);});
details.appendChild(grid);els.freshnessPanel.appendChild(details);
}
function filterRecommendation(results,incidentCount){
return psSafe.recommendation(results,DATA.parameters,activeSuburb);
}
function purestProductRecommendations(results,recommendation){
if(recommendation&&recommendation.providerFirst)return[];
return[
{name:'Filtered Tap System',href:'/products/filtered-tap-system',image:{src:'https://cdn.shopify.com/s/files/1/0579/9378/9520/files/Filtered_Tap_2.png?v=1780547951&width=600',alt:'Filtered tap system installed at a kitchen sink'},badge:'Standard mixer option',body:'A 3-way mixer with under-sink carbon and sediment filtration. Compare the exact package, cartridge specification and installation requirements.',fit:'Fixed mixer preference'},
{name:'Pull-Out Filtered Tap System',href:'/products/pull-out-filtered-tap-system',image:{src:'https://cdn.shopify.com/s/files/1/0579/9378/9520/files/pull-out-mixer-03-pullout-in-hand.png?width=600',alt:'Pull-out filtered mixer tap in use'},badge:'Pull-out mixer option',body:'An integrated filtered-water outlet alongside the unfiltered pull-out hot and cold outlet. Choose normal flow or wide rinse spray on the unfiltered side.',fit:'Pull-out flexibility'},
{name:'Reverse Osmosis System',href:'/products/reverse-osmosis-system',image:{src:'https://cdn.shopify.com/s/files/1/0579/9378/9520/files/SF407808.jpg?v=1766105861&width=600',alt:'Reverse osmosis system installed under a sink'},badge:'Compare the specification',body:'A tankless, pump-assisted under-sink system. Match any required dissolved-contaminant reduction to evidence for the exact complete system.',fit:'Discuss the treatment goal'},
{name:'Commercial Water Filters',href:'/collections/commercial',images:[{src:'https://cdn.shopify.com/s/files/1/0579/9378/9520/files/SF407557_a8f358e0-56ec-4f10-9cd6-46e8b53e18b0.jpg?v=1758200133&width=360',alt:'Plumbed standing water cooler'},{src:'https://cdn.shopify.com/s/files/1/0579/9378/9520/files/SF407605.jpg?v=1757640729&width=360',alt:'Commercial drinking water bubbler'}],badge:'Workplace options',body:'Compare managed rental and outright purchase for your site. Select equipment around usage, access and servicing, not a suburb-level water diagnosis.',fit:'Business drinking water'}
];
}
function renderProductRecommendations(parent,results,recommendation){
var wrap=document.createElement('div');
wrap.className='ps-wc-product-options';
var heading=document.createElement('div');
heading.className='ps-wc-product-options__heading';
var title=document.createElement('strong');
if(recommendation&&recommendation.providerFirst)return;
title.textContent='Purest options to compare';
var note=document.createElement('span');
note.textContent='Equipment options, not a diagnosis or a requirement to buy a filter.';
heading.appendChild(title);
heading.appendChild(note);
wrap.appendChild(heading);
purestProductRecommendations(results,recommendation).forEach(function(product){
var row=document.createElement('a');
row.className='ps-wc-product-option';
row.href=product.href;
row.addEventListener('click',function(){
track('water_checker_product_recommendation_clicked',{
product_name:product.name,
href:product.href,
recommendation_level:recommendation?recommendation.level:null
});
});
var media=document.createElement('span');
media.className=product.images?'ps-wc-product-option__media ps-wc-product-option__media--pair':'ps-wc-product-option__media';
var images=product.images||(product.image?[product.image]:[]);
images.forEach(function(image){
var img=document.createElement('img');
img.src=image.src;
img.alt=image.alt;
img.loading='lazy';
img.width=product.images?180:220;
img.height=product.images?180:220;
media.appendChild(img);
});
var content=document.createElement('span');
content.className='ps-wc-product-option__content';
var nameLine=document.createElement('span');
nameLine.className='ps-wc-product-option__name';
nameLine.textContent=product.name;
var body=document.createElement('span');
body.className='ps-wc-product-option__body';
body.textContent=product.body;
content.appendChild(nameLine);
content.appendChild(body);
var meta=document.createElement('span');
meta.className='ps-wc-product-option__meta';
var badge=document.createElement('span');
badge.className='ps-wc-product-option__badge';
badge.textContent=product.badge;
var fit=document.createElement('span');
fit.className='ps-wc-product-option__fit';
fit.textContent=product.fit;
meta.appendChild(badge);
meta.appendChild(fit);
row.appendChild(media);
row.appendChild(content);
row.appendChild(meta);
wrap.appendChild(row);
});
parent.appendChild(wrap);
}
function appendTextList(parent,items){
var list=document.createElement('ul');
items.forEach(function(item){
var li=document.createElement('li');
li.textContent=item;
list.appendChild(li);
});
parent.appendChild(list);
}
function renderDecisionCards(record,provider,zone,results){
if(!els.filterMatchCard||!els.providerFirstCard)return;
clearNode(els.filterMatchCard);clearNode(els.providerFirstCard);
var rec=filterRecommendation(results,incidentsFor(record,provider,zone).length);
var label=document.createElement('p');label.className='ps-wc-decision-eyebrow';label.textContent='Next step';
var title=document.createElement('h3');title.textContent=rec.title;
var body=document.createElement('p');body.textContent=rec.body;
els.filterMatchCard.appendChild(label);els.filterMatchCard.appendChild(title);els.filterMatchCard.appendChild(body);appendTextList(els.filterMatchCard,rec.reasons);
if(!rec.providerFirst)renderProductRecommendations(els.filterMatchCard,results,rec);
var h=document.createElement('h3');h.textContent='When your water retailer comes first';
var p=document.createElement('p');p.textContent='For an active notice, sudden discolouration, chemical smell or illness concern, check current advice from '+(provider?provider.name:'your retailer')+'. A historical reading cannot resolve a current incident.';
els.providerFirstCard.appendChild(h);els.providerFirstCard.appendChild(p);
if(provider&&/^https:\/\//.test(provider.website||'')){var a=document.createElement('a');a.href=provider.website;a.target='_blank';a.rel='noopener';a.className='ps-wc-text-link';a.textContent='Open '+provider.name+' website';els.providerFirstCard.appendChild(a);}
}
var PARAM_ICONS={
'droplet':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 2.5C10 2.5 4.5 9.2 4.5 12.7C4.5 15.9 6.9 17.9 10 17.9C13.1 17.9 15.5 15.9 15.5 12.7C15.5 9.2 10 2.5 10 2.5Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M7.3 13C7.3 14.4 8.3 15.2 9.5 15.4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
'shield':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 2.6L16.5 5V9.7C16.5 13.7 13.8 16.7 10 17.8C6.2 16.7 3.5 13.7 3.5 9.7V5L10 2.6Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>',
'check-shield':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 2.6L16.5 5V9.7C16.5 13.7 13.8 16.7 10 17.8C6.2 16.7 3.5 13.7 3.5 9.7V5L10 2.6Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M7.3 9.9L9.2 11.8L12.9 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
'scale':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 3V17M6 6H14M6 6L3.8 10.5C3.8 11.7 4.8 12.4 6 12.4C7.2 12.4 8.2 11.7 8.2 10.5L6 6ZM14 6L11.8 10.5C11.8 11.7 12.8 12.4 14 12.4C15.2 12.4 16.2 11.7 16.2 10.5L14 6Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>',
'wave':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M2.5 8C4 6.3 5.5 6.3 7 8C8.5 9.7 10 9.7 11.5 8C13 6.3 14.5 6.3 16 8C17.5 9.7 17.5 9.7 17.5 9.7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.5 13C4 11.3 5.5 11.3 7 13C8.5 14.7 10 14.7 11.5 13C13 11.3 14.5 11.3 16 13" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
'crystal':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5.5 4H14.5L18 9L10 18L2 9L5.5 4Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M2 9H18M7 4L10 9L10 18M13 4L10 9" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/></svg>',
'pipe':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M3 7H10C12.2 7 14 8.8 14 11V14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><rect x="2.3" y="4.3" width="5.4" height="5.4" rx="1" stroke="currentColor" stroke-width="1.3"/><rect x="11.7" y="11.7" width="5.4" height="5.4" rx="1" stroke="currentColor" stroke-width="1.3"/></svg>',
'building':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><rect x="4" y="2.5" width="9" height="15" rx="0.5" stroke="currentColor" stroke-width="1.3"/><path d="M13 8.5H16.2V17.5H13" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M6.5 5.5H10.5M6.5 8.5H10.5M6.5 11.5H10.5M6.5 14.5H10.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>',
'pin':'<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 18C10 18 15.5 12.6 15.5 8.3C15.5 5.1 13 2.5 10 2.5C7 2.5 4.5 5.1 4.5 8.3C4.5 12.6 10 18 10 18Z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="10" cy="8.2" r="2.1" stroke="currentColor" stroke-width="1.3"/></svg>'
};
function confidenceForResult(result){
return psSafe.context(result,activeSuburb);
}
function addQualityBadge(card,result){
var confidence=confidenceForResult(result);
var badge=document.createElement('span');
badge.className='ps-wc-confidence-badge'+(result.scope==='system_wide'||result.scope==='not_published'?' ps-wc-confidence-badge--soft':'');
badge.textContent=confidence.label;
badge.title=confidence.detail;
var head=card.querySelector('.ps-wc-quality-head');
if(head)head.appendChild(badge);
}
function qualityPlainStatus(param,result){
return psSafe.assess(param,result);
}
function addQualityPlainStatus(card,param,result){
var status=qualityPlainStatus(param,result);
var node=document.createElement('div');
node.className='ps-wc-quality-plain ps-wc-quality-plain--'+status.tone;
var label=document.createElement('strong');
label.textContent=status.label;
var body=document.createElement('span');
body.textContent=status.body;
node.appendChild(label);
node.appendChild(body);
var valueNode=card.querySelector('.ps-wc-quality-value');
if(valueNode&&valueNode.nextSibling){
card.insertBefore(node,valueNode.nextSibling);
}else{
card.appendChild(node);
}
}
function renderSourceDrawer(card,result,benchmarks){
var hasResultSource=result.source_url||result.source_publication||result.date_retrieved;
var hasGuidelines=benchmarks&&benchmarks.length;
if(!hasResultSource&&!hasGuidelines)return;
var details=document.createElement('details');
details.className='ps-wc-source-drawer';
var summary=document.createElement('summary');
summary.textContent='View sources';
details.appendChild(summary);
var list=document.createElement('div');
list.className='ps-wc-source-list';
if(hasResultSource){
var resultItem=document.createElement('p');
var resultLabel=result.source_org||'Water authority';
if(result.source_url){
var resultLink=document.createElement('a');
resultLink.href=result.source_url;
resultLink.target='_blank';
resultLink.rel='noopener';
resultLink.textContent=resultLabel;
resultItem.appendChild(resultLink);
}else{
resultItem.appendChild(document.createTextNode(resultLabel));
}
var publication=[];
if(result.source_publication)publication.push(result.source_publication);
if(result.reporting_period)publication.push(result.reporting_period);
if(result.date_retrieved)publication.push('retrieved '+result.date_retrieved);
if(publication.length)resultItem.appendChild(document.createTextNode(' - '+publication.join(', ')));
list.appendChild(resultItem);
}
(benchmarks||[]).forEach(function(benchmark){
if(!benchmark.source_url)return;
var item=document.createElement('p');
var link=document.createElement('a');
link.href=benchmark.source_url;
link.target='_blank';
link.rel='noopener';
link.textContent=benchmark.jurisdiction+' - '+(benchmark.source_label||benchmark.agency);
item.appendChild(link);
if(benchmark.last_verified)item.appendChild(document.createTextNode(' - verified '+benchmark.last_verified));
list.appendChild(item);
});
details.appendChild(list);
var sourceNode=card.querySelector('.ps-wc-quality-source');
card.insertBefore(details,sourceNode||null);
}
function renderGuidelineComparison(card,result){
var ref=psSafe.reference(result.parameter_id);
var benchmarks=(DATA.international_guidelines||[]).filter(function(b){return b.parameter_id===result.parameter_id;});
var details=document.createElement('details');details.className='ps-wc-guideline-compare';
var summary=document.createElement('summary');summary.textContent='Guideline and reporting context';details.appendChild(summary);
var note=document.createElement('p');note.className='ps-wc-guideline-note';
note.textContent='A numerical comparison is not a compliance assessment. Sampling method, analyte, units, reporting period and any range must match. Historic network results do not establish tap-water safety today.';details.appendChild(note);
if(ref){
var value=document.createElement('p');var strong=document.createElement('strong');
strong.textContent=ref.label+': '+(ref.min!==undefined?ref.min+'–':'')+ref.max+' '+ref.unit;
value.appendChild(strong);value.appendChild(document.createTextNode(' ('+ref.kind+' reference; checked '+ref.verified_on+'). '+(ref.note||'')+' '));
var link=document.createElement('a');link.href=ref.source_url;link.rel='noopener';link.target='_blank';link.textContent='Read NHMRC source';value.appendChild(link);details.appendChild(value);
}
if(benchmarks.length){
var old=document.createElement('p');old.textContent='Other references in the dataset may use different methods or dates. Follow their original source; no automatic international pass/fail grade is assigned here.';details.appendChild(old);
}
var source=card.querySelector('.ps-wc-quality-source');card.insertBefore(details,source||null);
renderSourceDrawer(card,result,benchmarks);
}
function renderQuality(zone,provider){
clearNode(els.qualityGrid);
var results=displayResultsForZone(zone,provider);
results.forEach(function(result){
var param=byId(DATA.parameters||[],result.parameter_id);if(!param)return;
var node=els.tplQualityCard.content.cloneNode(true),card=node.querySelector('.ps-wc-quality-card');
card.classList.add('ps-wc-quality-card--'+result.parameter_id);
if(!psSafe.available(result))card.classList.add('is-unavailable');
if(result.scope==='system_wide')card.classList.add('is-network-wide');
var icon=node.querySelector('.ps-wc-quality-icon');if(icon&&param.icon&&PARAM_ICONS[param.icon])icon.innerHTML=PARAM_ICONS[param.icon];
node.querySelector('.ps-wc-quality-name').textContent=param.name;addQualityBadge(card,result);
node.querySelector('.ps-wc-quality-value strong').textContent=psSafe.available(result)?String(result.value):'Not published';
node.querySelector('.ps-wc-quality-value span').textContent=psSafe.available(result)?(result.unit||''):'';
addQualityPlainStatus(card,param,result);
node.querySelector('.ps-wc-quality-context').textContent=psSafe.context(result,activeSuburb).detail;
var bar=node.querySelector('.ps-wc-quality-bar');if(bar)bar.hidden=true;
if(psSafe.available(result))renderGuidelineComparison(card,result);
var learn=[];
if(!isPending(result.range))learn.push('Range as supplied in the report: '+result.range+'.');
if(result.reporting_period)learn.push('Reporting period: '+result.reporting_period+'.');
learn.push('The original value is retained. Missing, undetected and bounded values are not converted into zero or an exact measurement. Read the original report for sampling method and current provider advice for current conditions.');
var learnBody=node.querySelector('.ps-wc-learn-body');learnBody.textContent=learn.join(' ');
var source=[];if(result.source_org)source.push(result.source_org);if(result.reporting_period)source.push(result.reporting_period);
node.querySelector('.ps-wc-quality-source').textContent=source.length?'Source: '+source.join(', ')+(result.scope==='system_wide'?' — network-wide, not specific to this suburb.':''):'No source organisation or reporting period mapped.';
var button=node.querySelector('.ps-wc-learn-more');button.addEventListener('click',function(){var open=learnBody.classList.toggle('is-open');button.setAttribute('aria-expanded',open?'true':'false');});
els.qualityGrid.appendChild(node);
});
}
function incidentMatches(incident,record,provider,zone){
var suburbHit=(incident.affected_suburbs||[]).some(function(s){return normalize(s)===normalize(record.suburb);});
var postcodeHit=(incident.affected_postcodes||[]).indexOf(record.postcode)!==-1;
var providerHit=provider&&incident.provider_id===provider.id&&incident.geographic_scope==='provider_wide';
var zoneHit=zone&&incident.zone_id===zone.id;
return suburbHit||postcodeHit||providerHit||zoneHit;
}
function formatIncidentDate(incident){
if(isPending(incident.date_started))return'';
var d=new Date(incident.date_started);
if(isNaN(d.getTime()))return incident.date_started;
return d.toLocaleDateString('en-AU',{month:'short',year:'numeric'});
}
function renderHistory(record,provider,zone){
clearNode(els.historyTimeline);
var incidents=(DATA.incidents||[]).filter(function(incident){
return incidentMatches(incident,record,provider,zone)&&!isPending(incident.summary);
});
if(!incidents.length){
setHidden(els.historySection,true);
return;
}
setHidden(els.historySection,false);
els.historyTimeline.classList.remove('is-empty');
incidents.forEach(function(incident){
var node=els.tplHistoryEvent.content.cloneNode(true);
node.querySelector('.ps-wc-history-event').setAttribute('data-status',incident.status||'');
node.querySelector('.ps-wc-history-date').textContent=formatIncidentDate(incident);
node.querySelector('.ps-wc-history-title').textContent=incident.title;
node.querySelector('.ps-wc-history-summary').textContent=incident.summary;
var badges=node.querySelector('.ps-wc-history-badges');
badges.appendChild(makeChip('Historical event','historical'));
if(incident.status==='resolved')badges.appendChild(makeChip('Resolved','resolved'));
else if(incident.status)badges.appendChild(makeChip(capitalize(incident.status),'current'));
var detail=node.querySelector('.ps-wc-history-detail');
var learnBtn=node.querySelector('.ps-wc-learn-more');
if(!isPending(incident.detail)){
detail.textContent=incident.detail;
learnBtn.addEventListener('click',function(){
var open=detail.classList.toggle('is-open');
learnBtn.setAttribute('aria-expanded',open?'true':'false');
if(open)track('history_event_opened',{incident_id:incident.id});
});
}else{
learnBtn.remove();
}
var meta=node.querySelector('.ps-wc-history-meta');
if(incident.source_org){
var srcSpan=document.createElement('span');
srcSpan.textContent='Source: '+incident.source_org;
meta.appendChild(srcSpan);
}
if(!isPending(incident.source_url)){
var a=document.createElement('a');
a.href=incident.source_url;
a.target='_blank';
a.rel='noopener';
a.textContent='Read original notice →';
meta.appendChild(a);
}
els.historyTimeline.appendChild(node);
});
}
function makeChip(label,kind){
var span=document.createElement('span');
span.className='ps-wc-chip ps-wc-chip--'+kind;
span.textContent=label;
return span;
}
function capitalize(s){return s?s.charAt(0).toUpperCase()+s.slice(1).replace(/_/g,' '):s;}
function renderCtaFacts(record,provider,zone){
if(!els.ctaFacts)return;clearNode(els.ctaFacts);
var items=[{value:provider?provider.name:'Not confirmed',label:'Mapped retailer context'},{value:String(qualityResultsForZone(zone).length),label:'Sourced supply-zone results, not tap tests'},{value:String(incidentsFor(record,provider,zone).length),label:'Historical records mapped; not a live alert count'}];
items.forEach(function(f){var div=document.createElement('div');div.className='ps-wc-cta-fact';var strong=document.createElement('strong');strong.textContent=f.value;var span=document.createElement('span');span.textContent=f.label;div.appendChild(strong);div.appendChild(span);els.ctaFacts.appendChild(div);});
}
var propertyStarted=false;
var PROPERTY_OPTION_META={
observations:{
chlorine_taste:{icon:'droplet',detail:'Often a taste and odour question.'},
metallic_taste:{icon:'pipe',detail:'Can involve tapware or plumbing.'},
sediment:{icon:'wave',detail:'Particles, grit or visible specks.'},
cloudiness:{icon:'wave',detail:'Clarity signal worth matching.'},
discolouration:{icon:'droplet',detail:'Check if sudden or recurring.'},
scale:{icon:'crystal',detail:'Usually linked to hardness.'},
smell:{icon:'droplet',detail:'Taste and odour pathway.'},
nothing:{icon:'check-shield',detail:'Use the suburb profile only.'},
other:{icon:'pin',detail:'We can talk through it.'}
},
priorities:{
taste:{icon:'droplet',detail:'Everyday drinking water.'},
chlorine:{icon:'droplet',detail:'Carbon filtration discussion.'},
sediment:{icon:'wave',detail:'Particle and clarity focus.'},
contaminants:{icon:'shield',detail:'Match to certified claims.'},
family:{icon:'shield',detail:'Extra peace of mind.'},
peace_of_mind:{icon:'check-shield',detail:'Confidence and convenience.'},
appliances:{icon:'crystal',detail:'Scale and fittings.'},
other:{icon:'pin',detail:'Something specific.'}
},
home_age:{
under_10:{detail:'Newer home'},
'10_30':{detail:'Established home'},
'30_50':{detail:'Older fittings possible'},
over_50:{detail:'Plumbing context matters'},
not_sure:{detail:'Keep it cautious'}
},
pipes_replaced:{
yes:{detail:'Lower plumbing uncertainty'},
no:{detail:'Tap-specific context matters'},
not_sure:{detail:'Worth checking if concerned'}
}
};
function questionById(id){
var pq=DATA.property_questions;
return pq&&pq.questions?byId(pq.questions,id):null;
}
function questionHeading(id,fallback){
if(id==='observations')return'1. Pick what you notice';
if(id==='home_age')return'2. Add quick home context';
if(id==='pipes_replaced')return'Pipe and tapware certainty';
if(id==='priorities')return'3. Choose what you want improved';
return fallback;
}
function renderQuestion(q){
var wrap=document.createElement('div');
wrap.className='ps-wc-q ps-wc-q--'+q.id;
var label=document.createElement('span');
label.className='ps-wc-q-label';
label.textContent=questionHeading(q.id,q.label);
wrap.appendChild(label);
if(q.id==='observations'){
var hint=document.createElement('p');
hint.className='ps-wc-q-hint';
hint.textContent='Start with the thing that made you search. You can choose more than one.';
wrap.appendChild(hint);
}
var optionsWrap=document.createElement('div');
optionsWrap.className='ps-wc-options ps-wc-options--'+(q.id==='observations'?'cards':(q.id==='home_age'||q.id==='pipes_replaced'?'compact':'chips'));
optionsWrap.setAttribute('role',q.type==='single'?'radiogroup':'group');
optionsWrap.setAttribute('aria-label',q.label);
q.options.forEach(function(opt,i){
var optWrap=document.createElement('span');
optWrap.className='ps-wc-option ps-wc-option--'+q.id;
var input=document.createElement('input');
input.type=q.type==='single'?'radio':'checkbox';
input.name='pq-'+q.id;
input.id='pq-'+q.id+'-'+i;
input.value=opt.value;
input.addEventListener('change',function(){
if(!propertyStarted){propertyStarted=true;track('property_questions_started',{});}
});
var lbl=document.createElement('label');
lbl.setAttribute('for',input.id);
var meta=PROPERTY_OPTION_META[q.id]&&PROPERTY_OPTION_META[q.id][opt.value]?PROPERTY_OPTION_META[q.id][opt.value]:{};
if(q.id==='observations'||q.id==='priorities'){
var icon=document.createElement('span');
icon.className='ps-wc-option-icon';
icon.innerHTML=PARAM_ICONS[meta.icon]||PARAM_ICONS.pin||'';
lbl.appendChild(icon);
}
var text=document.createElement('span');
text.className='ps-wc-option-text';
var title=document.createElement('strong');
title.textContent=opt.label;
text.appendChild(title);
if(meta.detail){
var detail=document.createElement('small');
detail.textContent=meta.detail;
text.appendChild(detail);
}
lbl.appendChild(text);
optWrap.appendChild(input);
optWrap.appendChild(lbl);
optionsWrap.appendChild(optWrap);
});
wrap.appendChild(optionsWrap);
return wrap;
}
function renderPropertyForm(){
clearNode(els.propertyForm);
propertyStarted=false;
var pq=DATA.property_questions;
if(!pq||!pq.questions)return;
var homeRow=document.createElement('div');
homeRow.className='ps-wc-home-context-row';
['observations','home_age','pipes_replaced','priorities'].forEach(function(id){
var q=questionById(id);
if(!q)return;
if(id==='home_age'||id==='pipes_replaced'){
homeRow.appendChild(renderQuestion(q));
if(id==='pipes_replaced')els.propertyForm.appendChild(homeRow);
}else{
els.propertyForm.appendChild(renderQuestion(q));
}
});
}
function collectPropertyAnswers(){
var pq=DATA.property_questions;
var answers={};
if(!pq||!pq.questions)return answers;
pq.questions.forEach(function(q){
if(q.type==='single'){
var checked=els.propertyForm.querySelector('input[name="pq-'+q.id+'"]:checked');
answers[q.id]=checked?checked.value:null;
}else{
var boxes=els.propertyForm.querySelectorAll('input[name="pq-'+q.id+'"]:checked');
answers[q.id]=Array.prototype.map.call(boxes,function(b){return b.value;});
}
});
return answers;
}
function optionLabel(question,value){
var opt=question.options.filter(function(o){return o.value===value;})[0];
return opt?opt.label:value;
}
if(els.propertySubmit){
els.propertySubmit.addEventListener('click',function(){
var answers=collectPropertyAnswers();
track('property_questions_completed',{});
buildSummary(answers);
});
}
if(els.propertySkip){
els.propertySkip.addEventListener('click',function(){
buildSummary(null);
});
}
function resultFor(results,parameterId){
return results.filter(function(r){return r.parameter_id===parameterId;})[0]||null;
}
function shortValue(result){
return result?result.value+(result.unit?' '+result.unit:''):null;
}
function answerHas(answers,key,values){
if(!answers||!answers[key])return false;
var current=Array.isArray(answers[key])?answers[key]:[answers[key]];
return values.some(function(value){return current.indexOf(value)!==-1;});
}
function selectedLabels(question,values){
if(!question||!values||!values.length)return[];
return values.filter(function(v){return v!=='nothing';}).map(function(v){return optionLabel(question,v);});
}
function selectedValues(answers,key){
if(!answers||!answers[key])return[];
return Array.isArray(answers[key])?answers[key]:[answers[key]];
}
function selectedOptionLabelsById(id,values){
var q=questionById(id);
return selectedLabels(q,values);
}
function tapMatchDiagnosis(answers,qualityResults){
var observations=selectedValues(answers,'observations'),priorities=selectedValues(answers,'priorities');
var rec=psSafe.recommendation(qualityResults,DATA.parameters,activeSuburb);
if(rec.providerFirst)return{label:'Provider advice first',title:rec.title,body:rec.body,productNote:'No product is matched to this reported result.'};
if(observations.indexOf('discolouration')!==-1)return{label:'Check the cause first',title:'Discolouration needs context',body:'Check current retailer notices and whether the change is sudden. A filter recommendation cannot diagnose the cause from a questionnaire.',productNote:'Discuss treatment only after the cause and any official advice are understood.'};
if(answerHas(answers,'observations',['metallic_taste'])||answerHas(answers,'priorities',['contaminants']))return{label:'Your selected concern',title:'Start with the substance you want to address',body:'Metallic taste is not a laboratory result. Supply reports and your plumbing can both matter; match any treatment to verified performance for the actual concern.',productNote:'Ask about testing and exact system evidence before selecting a product.'};
if(answerHas(answers,'observations',['scale'])||answerHas(answers,'priorities',['appliances']))return{label:'Your selected concern',title:'Discuss scale-management options',body:'A drinking-water carbon and sediment filter is not automatically a whole-home softener. Check the hardness reporting units and the equipment you want to protect.',productNote:'Confirm whether the objective is drinking-water taste or scale treatment.'};
if(answerHas(answers,'observations',['sediment','cloudiness'])||answerHas(answers,'priorities',['sediment']))return{label:'Your selected concern',title:'Check particles and cloudiness',body:'Visible changes do not identify a contaminant. For sudden or persistent changes, check the cause and retailer advice before choosing filtration.',productNote:'Compare particle-reduction specifications once the cause is understood.'};
if(answerHas(answers,'observations',['chlorine_taste','smell'])||answerHas(answers,'priorities',['taste','chlorine']))return{label:'Your selected preference',title:'Focus on taste and odour',body:'First confirm the disinfectant and the exact cartridge claim. A taste preference is not evidence that the supply is unsafe.',productNote:'Compare the fixed mixer and pull-out mixer for kitchen functionality.'};
return{label:'Your preferences',title:'Use the reports as background, not a diagnosis',body:'No symptoms selected does not prove the absence of a problem. Missing or indicative data is not scored as low risk.',productNote:'Choose around convenience and independently supported filtration goals.'};
}
function appendSummaryMetric(parent,label,value,detail){
var item=document.createElement('div');
item.className='ps-wc-summary-metric';
var l=document.createElement('span');
l.textContent=label;
var v=document.createElement('strong');
v.textContent=value||'Not published';
var d=document.createElement('p');
d.textContent=detail;
item.appendChild(l);
item.appendChild(v);
item.appendChild(d);
parent.appendChild(item);
}
function summaryProofCard(title,body,label){
var card=document.createElement('div');
card.className='ps-wc-summary-proof';
var eyebrow=document.createElement('span');
eyebrow.textContent=label;
var h=document.createElement('h3');
h.textContent=title;
var p=document.createElement('p');
p.textContent=body;
card.appendChild(eyebrow);
card.appendChild(h);
card.appendChild(p);
return card;
}
function buildSummary(answers){
if(!activeSuburb||!DATA)return;clearNode(els.summaryBlocks);
var provider=providerFor(activeSuburb),zone=zoneFor(activeSuburb),results=displayResultsForZone(zone,provider);
var rec=psSafe.recommendation(results,DATA.parameters,activeSuburb),diagnosis=tapMatchDiagnosis(answers,results);
if(answerHas(answers,'observations',['discolouration']))rec=Object.assign({},rec,{providerFirst:true});
var hero=document.createElement('div');hero.className='ps-wc-summary-match';
var copy=document.createElement('div');copy.className='ps-wc-summary-match-copy';
var eyebrow=document.createElement('span');eyebrow.className='ps-wc-summary-match-eyebrow';eyebrow.textContent=diagnosis.label;
var title=document.createElement('h3');title.textContent=diagnosis.title;
var body=document.createElement('p');body.textContent=diagnosis.body;
copy.appendChild(eyebrow);copy.appendChild(title);copy.appendChild(body);
var selected=document.createElement('div');selected.className='ps-wc-summary-selected';
selectedOptionLabelsById('observations',selectedValues(answers,'observations')).concat(selectedOptionLabelsById('priorities',selectedValues(answers,'priorities'))).slice(0,5).forEach(function(t){var pill=document.createElement('span');pill.textContent=t;selected.appendChild(pill);});copy.appendChild(selected);
var metrics=document.createElement('div');metrics.className='ps-wc-summary-metrics';
['chlorine','turbidity','hardness','lead'].forEach(function(id){var r=resultFor(results,id),p=byId(DATA.parameters||[],id);appendSummaryMetric(metrics,p?p.name:id,psSafe.available(r)?shortValue(r):'Not published',psSafe.context(r,activeSuburb).detail);});
hero.appendChild(copy);hero.appendChild(metrics);els.summaryBlocks.appendChild(hero);
var proof=document.createElement('div');proof.className='ps-wc-summary-proof-grid';
proof.appendChild(summaryProofCard(provider?provider.name:'Provider not confirmed',mappingCoverageLabel(activeSuburb)+'. Confirm any uncertain mapping with the retailer.','Supply context'));
proof.appendChild(summaryProofCard('Published reporting only',(results.some(psSafe.sourced)?sourceYearSummary(results.filter(psSafe.sourced)):'No sourced reporting period available')+'. Not a live alert or tap sample.','Reporting period'));
proof.appendChild(summaryProofCard('Your selections are not test results','A questionnaire does not inspect plumbing or establish contaminant levels.','Household context'));
proof.appendChild(summaryProofCard('Check current retailer advice','Sudden changes, chemical smells, illness concerns or active notices require official advice.','Provider first'));
els.summaryBlocks.appendChild(proof);
if(!rec.providerFirst){var products=document.createElement('div');products.className='ps-wc-summary-products';var h=document.createElement('h3');h.textContent='Options to compare, not a water-safety prescription';var p=document.createElement('p');p.textContent=diagnosis.productNote;products.appendChild(h);products.appendChild(p);renderProductRecommendations(products,results,rec);els.summaryBlocks.appendChild(products);}
if(rec.providerFirst&&provider&&/^https:\/\//.test(provider.website||'')){var a=document.createElement('a');a.href=provider.website;a.target='_blank';a.rel='noopener';a.className='ps-wc-btn ps-wc-btn--primary';a.textContent='Check '+provider.name+' advice';els.summaryBlocks.appendChild(a);}
updateCtaChips(selectedValues(answers,'priorities'));setHidden(els.summarySection,false);psGateSales(rec);els.summarySection.scrollIntoView({behavior:'smooth',block:'start'});
}
function updateCtaChips(priorities){
if(!els.ctaChips)return;
var chips=els.ctaChips.querySelectorAll('[data-priority]');
chips.forEach(function(chip){
chip.classList.toggle('is-matched',priorities.indexOf(chip.dataset.priority)!==-1);
});
}
if(els.ctaSection){
els.ctaSection.addEventListener('click',function(e){
var link=e.target.closest('a');
if(!link)return;
track('filtration_cta_clicked',{href:link.getAttribute('href')});
});
}
root.addEventListener('click',function(e){
var suburbLink=e.target.closest('.ps-wc-suburb-anchor');
if(suburbLink){
if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey||e.button>0)return;
var suburbName=suburbLink.getAttribute('data-suburb')||suburbLink.textContent;
track('water_checker_popular_suburb_clicked',{
suburb:suburbName
});
if(suburbName&&els.input){
els.input.value=suburbName;
}
if(DATA&&suburbName){
e.preventDefault();
resolveQuery(suburbName);
}
return;
}
var sourceLink=e.target.closest('.ps-wc-source-band a');
if(!sourceLink)return;
track('water_checker_source_clicked',{
href:sourceLink.getAttribute('href'),
label:sourceLink.textContent
});
});
function psGateSales(recommendation){
var blocked=!!(recommendation&&recommendation.providerFirst);
setHidden(els.ctaSection,blocked);
setHidden(document.getElementById('ps-wc-profile-cta'),blocked);
if(els.scoreboard)els.scoreboard.querySelectorAll('.ps-wc-journey-actions').forEach(function(el){el.hidden=blocked;});
if(els.filterMatchCard)els.filterMatchCard.querySelectorAll('.ps-wc-product-options').forEach(function(el){el.hidden=blocked;});
}
if(els.propertyForm)els.propertyForm.addEventListener('change',function(e){
var input=e.target;
if(!input||input.name!=='pq-observations'||!input.checked)return;
els.propertyForm.querySelectorAll('input[name="pq-observations"]').forEach(function(other){
if(other!==input&&(input.value==='nothing'||other.value==='nothing'))other.checked=false;
});
});
track('water_checker_view',{});
loadData();
window.addEventListener('popstate',function(){
if(!DATA)return;
handleInitialUrlState();
});
})();
